import React from "react";

const OurStory = () => {
  return (
    <section className="about-section inner-page">
        <div className="container">
    <div className="our-story">
      <h1>Our Story</h1>
      <section>
        <h2>Organization Vision and Mission</h2>
        <div>
          <h3>Mission</h3>
          <p>
            To develop a model to increase income and generate employment at the
            grassroots level through equitable and holistic development.
          </p>
        </div>
        <div>
          <h3>Vision</h3>
          <p>
            Professionalizing the informal trade channel of fresh farm produce
            and creating gainful, dignified self-employment for families
            dependent on the agriculture sector. Designing holistic intervention
            models in poor communities to improve Health, Education,
            Agriculture, and Livelihoods (HEAL).
          </p>
        </div>
        <div>
          <h3>Goal</h3>
          <ul>
            <li>Organize and professionalize small and marginal farmers towards Natura-oriented farming.</li>
            <li>Connect street vendors and growers to the mainstream market.</li>
            <li>Generate livelihood opportunities by creating new market avenues.</li>
            <li>Reduce information asymmetry in the agriculture supply chain.</li>
            <li>Improve education among disadvantaged communities, targeting youth development.</li>
            <li>Improve health, hygiene, and sanitation among the poor.</li>
            <li>Enhance the livelihoods of disadvantaged communities.</li>
          </ul>
        </div>
      </section>

      <section>
        <h2>Main Strengths of Our Organization</h2>
        <ul>
          <li>Devoted, trained staff for implementing rural developmental activities.</li>
          <li>Strong connections with Panchayati Raj Institutions and the State Minority Commission of Madhya Pradesh, Bhopal.</li>
          <li>Awakened women SHGs, Co-Operatives, Volunteers, Partner CBBOs/NGOs/FPOs.</li>
          <li>
            Network of 200 Artisans, 6 FPOs, 1 LOGF, 10 SHGs, and 2 Co-operatives in Madhya Pradesh.
          </li>
        </ul>
      </section>

      <section>
        <h2>Key Learnings and Success</h2>
        <ul>
          <li>Community support ensures program success.</li>
          <li>Women involvement in development and social activities.</li>
          <li>Empowerment of minority women and youth.</li>
        </ul>
      </section>

      <section>
        <h2>Significant Achievements of the Trust</h2>
        <ul>
          <li>
            Formation and training of 6 FPOs and 1 LOGF of 50 farmers in Balaghat
            (M.P.) with financial support from NABARD.
          </li>
          <li>
            Training of Farmers, BoDs, CEOs, Accountants, and representatives on
            FPO management, rural technology, and capacity building for
            technology adoption.
          </li>
          <li>
            Assistance to rural communities, especially Tribes, in conserving and regenerating forests and common property resources.
          </li>
          <li>
            Motivating SHG members, Women Co-operatives, and CBOs to contest and
            advocate effectively in Gram Panchayat elections.
          </li>
          <li>
            Establishment of income generation projects by SHG and Co-operative members.
          </li>
          <li>
            Formation of 120 Farmers Clubs in Balaghat district with NABARD's
            support.
          </li>
          <li>
            Establishment of 8 Mahila Griha Udyogs, with registration in MSME,
            benefiting 250 women.
          </li>
        </ul>
      </section>

      <section>
        <h2>Areas of Competence</h2>
        <ul>
          <li>Skill Development and Training in rural areas.</li>
          <li>Farmers empowerment through training and formation of FPOs.</li>
          <li>Rural poverty, sanitation, energy, and technology solutions.</li>
          <li>Environmental planning and natural resource management.</li>
          <li>Micro-planning for sustainable development.</li>
        </ul>
      </section>

      <section>
        <h2>Organization Structure</h2>
        <p>
          (Add content or chart for organization structure here as required.)
        </p>
      </section>
    </div>
    </div>
    </section>
  );
};

export default OurStory;
